module.exports = __webpack_public_path__ + "static/media/Template_17.db9a9e8b.png";